import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Row, Col, Form, Table, Button } from "react-bootstrap";
import { getProjecTask } from "../../store/actions/projects/projectTasksActions";
import { getProject } from "../../store/actions/projects/projectsActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
// import TaskTable from "./TaskTable";
import { Cache } from "aws-amplify";

import {
  addTaskRow,
  createDailyTaskAssignment,
  fetchDailyTask,
  fetchOptions,
} from "../../store/actions/timesheet/taskActions";
import DailyTaskForm from "./DailyTaskForm";
import moment from "moment";
import { TEAM_LEADER } from "../../store/actions/users/usersActions";

// import AssignTaskForm from './AssignTaskForm';
// import TaskAssignments from './TaskAssignments';

class DailyTaskById extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: "",
      confirmAction: "",
      status: "",
      readOnly: false,
      user_id: "",
      roleId: "",
      dailyTaskId: null,
      taskEntries: null,
      currentDate: false,
    };
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(this.props.location.search);
    const dailyTaskId = urlParams.get("id");
    const user_id = urlParams.get("user_id");
    this.setState({ dailyTaskId });
    this.setState({ user_id });

    this.props.fetchDailyTask(dailyTaskId, user_id);
    this.props.fetchOptions();
  }

  handleDateChange = (e) => {
    const selectedDate = e.target.value;
    this.setState({ selectedDate });
    // Fetch data based on the selected date using Redux actions
    // Example: this.props.getTasksByDate(selectedDate);
  };

  generateTaskForm = (isCurrentDate) => {
    this.state.taskEntries = this.props.dailyTasks.taskEntries;
    console.log(this.state.taskEntries);
    console.log(this.props.dailyTasks.taskEntries);
    return this.state.taskEntries.map((taskEntry) => {
      return (
        <DailyTaskForm
          key={taskEntry.entry_id}
          entry_id={taskEntry.entry_id}
          id={this.state.dailyTaskId}
          task={taskEntry}
          isCurrentDate={isCurrentDate}
          user_id={this.state.user_id}
        />
      );
    });
  };

  handleCreateTaskAssignment = () => {
    this.props.createDailyTaskAssignment(this.state.dailyTaskId);
  };

  render() {
    let taskName = "";
    let projectName = "";
    let taskDate;
    const { selectedDate } = this.state;
    const currentDate = moment().format("YYYY-MM-DD");
    let tasksheet_date = this.props.dailyTasks.taskDate;
    const isCurrentDate = tasksheet_date === currentDate;
    const roleId = Cache.getItem("roleId");
    const projectTask = this.props.dailyTasks.dailyTask;

    if (projectTask) {
      if (Object.keys(projectTask).length > 0) {
        const task = projectTask.task;
        if (task) {
          taskName = task.name;
        }

        const project = projectTask.dailyTask;
        if (project) {
          projectName = project.project_name;
        }
      }
    }

    return (
      <>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            {roleId !== TEAM_LEADER ? (
              <h5>Daily Tasks: {tasksheet_date}</h5>
            ) : (
              <h5>Team Daily Tasks: {tasksheet_date}</h5>
            )}
          </Col>
        </Row>
        <hr />
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Table>
              <thead className="align-center">
                <tr>
                  <th colSpan={2}>Project</th>
                  <th colSpan={2}>Task</th>
                  <th colSpan={1}>Actual/ Expected Transacts</th>
                  <th colSpan={2}>Status</th>
                  <th colSpan={2}>Quick Actions</th>
                  <th colSpan={1}>Start Time</th>
                  <th colSpan={1}>End Time</th>
                  <th colSpan={1}>Actual Time </th>
                  <th colSpan={2}>Actions</th>
                </tr>
              </thead>

              <tbody>
                {this.generateTaskForm(isCurrentDate)}
                {/* {projectTask.daily_task_data
                  ? projectTask.daily_task_data.map((task, index) => {
                      return (
                        <TaskTable
                          key={index}
                          index={index}
                          task={task}
                          date={taskDate}
                        />
                      );
                    })
                  : "Loading..."} */}
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col className="d-flex justify-content-between">
            <div className="d-flex align-items-center">
              Total Actual Time:&nbsp;
              <b>{this.props.dailyTasks.totalActualTime}</b>
            </div>
            {roleId !== TEAM_LEADER ? (
              <Button
                variant="primary"
                onClick={this.handleCreateTaskAssignment}
                disabled={!isCurrentDate}
              >
                <FontAwesomeIcon icon={faPlus} />
              </Button>
            ) : (
              <></>
            )}
          </Col>
        </Row>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  dailyTasks: state.dailyTasks,
});

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDailyTask: (...args) => dispatch(fetchDailyTask(...args)),
    fetchOptions: (...args) => dispatch(fetchOptions(...args)),
    createDailyTaskAssignment: (...args) =>
      dispatch(createDailyTaskAssignment(...args)),
    getProjecTask: (...args) => dispatch(getProjecTask(...args)),
    getProject: (...args) => dispatch(getProject(...args)),
    addTaskRow: () => dispatch(addTaskRow()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DailyTaskById)
);
